import { render, staticRenderFns } from "./Communications1.container.vue?vue&type=template&id=763f62de&scoped=true&"
import script from "./Communications1.container.vue?vue&type=script&lang=js&"
export * from "./Communications1.container.vue?vue&type=script&lang=js&"
import style0 from "./Communications1.container.vue?vue&type=style&index=0&id=763f62de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f62de",
  null
  
)

export default component.exports